module.exports = __webpack_public_path__ + "img/faq_en.c4f4339d.png";